import React from 'react';
import { TimeUtils } from '@colonist/utils';
export const Timer = ({ timeLeftInSeconds, className })=>{
    const formattedTime = TimeUtils.formatSecondsToElapsedString(timeLeftInSeconds !== null && timeLeftInSeconds !== void 0 ? timeLeftInSeconds : 0);
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, formattedTime);
};
